import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface PartagerMessagePictoProps extends pictoProps {
}

export interface PartagerMessagePictoState extends pictoState {
}

export class PartagerMessagePicto extends Picto<PartagerMessagePictoProps,PartagerMessagePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.partagerMessagePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(PartagerMessagePicto);
